import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TransactionInfoStateComponent } from './transaction-info-state.component';
import { TransactionStatesCardModule } from '@app/transactions/pages/transaction-states/transaction-states-card/transaction-states-card.module';
import { RouterModule, Routes } from '@angular/router';
import { StateChatModule } from '@app/transactions/components/state-chat/state-chat.module';
import { StepperTransactionStatesModule } from './stepper-transaction-states/stepper-transaction-states.module';
import { MatDividerModule } from '@angular/material/divider';

const routes: Routes = [
    {
        path: '',
        component: TransactionInfoStateComponent
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class TransactionInfoStateRoutingModule {}

@NgModule({
    declarations: [TransactionInfoStateComponent],
    exports: [TransactionInfoStateComponent],
    imports: [
        CommonModule,
        TransactionStatesCardModule,
        TransactionInfoStateRoutingModule,
        MatDividerModule,
        StepperTransactionStatesModule,
        StateChatModule
    ]
})
export class TransactionInfoStateModule {}
